module.exports = __webpack_public_path__ + "img/labor.9cb7a2e0.png";